/* GBQuote — the quote request page (2026-09-01; replaced the dialog). The lists
 * put the selection in the query string (?channel=…&lines=LOT~SIZE~QTY,…) so it
 * survives refresh and back; titles and display prices ride sessionStorage and
 * fall back to the lot number. The server reprices every line at submit, so the
 * payload carries only { lotNumber, size, quantity }. Typed contact details are
 * cached locally and restored, so a wrong tap never eats anyone's work. */
(function () {
  var root = document.querySelector('[data-gb-quote]');
  if (!root || root.tagName === 'DIALOG') return;

  var form = root.querySelector('[data-gb-quote-form]');
  var empty = root.querySelector('[data-gb-quote-empty]');
  var summary = root.querySelector('[data-gb-quote-summary]');
  var totalEl = root.querySelector('[data-gb-quote-total]');
  var shipline = root.querySelector('[data-gb-quote-shipline]');
  var cutoff = root.querySelector('[data-gb-quote-cutoff]');
  var done = root.querySelector('[data-gb-quote-done]');
  var doneRef = root.querySelector('[data-gb-quote-ref]');
  var doneEmail = root.querySelector('[data-gb-quote-email]');
  var errEl = root.querySelector('[data-gb-quote-error]');
  var send = root.querySelector('[data-gb-quote-send]');
  var trade = root.getAttribute('data-trade') === '1';

  var params = new URLSearchParams(window.location.search);
  var channel = params.get('channel') === 'roasted' ? 'roasted' : 'green';
  var backUrl = channel === 'roasted' ? '/apps/shop/trade' : '/pages/green';
  root.querySelectorAll('[data-gb-quote-back]').forEach(function (a) {
    a.setAttribute('href', backUrl);
  });

  function money(pence) {
    if (window.GBCart && window.GBCart.money) return window.GBCart.money(pence);
    return '£' + (pence / 100).toFixed(2);
  }

  // Display metadata (title + shown price) set by the sending list; the lot
  // number is the honest fallback when it's missing (direct visit, new device).
  var display = {};
  try {
    display = JSON.parse(sessionStorage.getItem('gb_quote_display') || '{}');
  } catch (e) {}

  var lines = (params.get('lines') || '')
    .split(',')
    .map(function (raw) {
      var bits = raw.split('~');
      return { lotNumber: bits[0] || '', size: bits[1] || '', quantity: parseInt(bits[2], 10) || 0 };
    })
    .filter(function (l) {
      return l.lotNumber && l.size && l.quantity > 0 && l.quantity <= 999;
    })
    .slice(0, 20);

  // The form is server-rendered VISIBLE (the normal case — CLS: revealing it late
  // shifted the footer by the whole form height); only the no-lines visit swaps.
  if (lines.length === 0) {
    form.hidden = true;
    empty.hidden = false;
    return;
  }
  var lead = root.querySelector('[data-gb-quote-lead]');
  if (lead && channel === 'roasted' && trade) lead.textContent = 'Coffee is at your trade rate.';
  if (cutoff) cutoff.hidden = channel !== 'roasted';
  if (shipline && channel === 'green') shipline.textContent = '+ shipping, in our reply · green coffee is zero-rated for VAT';

  var pence = 0;
  var known = true;
  lines.forEach(function (l) {
    var d = display[l.lotNumber + '~' + l.size] || {};
    var li = document.createElement('li');
    li.textContent = l.quantity + ' × ' + l.size + ' — ' + (d.title || l.lotNumber);
    if (typeof d.pence === 'number' && d.pence > 0) {
      var amt = document.createElement('span');
      amt.textContent = money(d.pence * l.quantity);
      li.appendChild(amt);
      pence += d.pence * l.quantity;
    } else {
      known = false;
    }
    summary.appendChild(li);
  });
  if (totalEl) totalEl.textContent = known ? money(pence) : 'in our reply';

  // Preserve user work across navigation and refresh.
  var CACHE = 'gb_quote_contact';
  var fields = ['name', 'email', 'company', 'phone', 'addressLine1', 'addressLine2', 'city', 'postcode', 'country'];
  try {
    var saved = JSON.parse(localStorage.getItem(CACHE) || '{}');
    fields.forEach(function (n) {
      if (form.elements[n] && !form.elements[n].value && typeof saved[n] === 'string') form.elements[n].value = saved[n];
    });
  } catch (e) {}
  form.addEventListener('input', function () {
    try {
      var out = {};
      fields.forEach(function (n) {
        if (form.elements[n] && form.elements[n].value) out[n] = form.elements[n].value;
      });
      localStorage.setItem(CACHE, JSON.stringify(out));
    } catch (e) {}
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (send.dataset.busy) return;
    if (form.reportValidity && !form.reportValidity()) return;
    var val = function (name) {
      var f = form.elements[name];
      return f && typeof f.value === 'string' ? f.value.trim() : '';
    };
    var payload = {
      channel: channel,
      name: val('name'),
      email: val('email'),
      company: val('company'),
      phone: val('phone'),
      addressLine1: val('addressLine1'),
      addressLine2: val('addressLine2'),
      city: val('city'),
      postcode: val('postcode'),
      country: val('country'),
      fax: val('fax'),
      lines: lines
    };
    send.dataset.busy = '1';
    errEl.hidden = true;
    var restore = window.GBUI && window.GBUI.busy ? window.GBUI.busy(send, 'Sending…') : function () {};
    fetch('/apps/shop/quotes', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () {
            return {};
          })
          .then(function (b) {
            return { ok: r.ok && b.ok !== false, body: b };
          });
      })
      .then(function (res) {
        delete send.dataset.busy;
        restore();
        if (res.ok) {
          form.hidden = true;
          done.hidden = false;
          // A tripped honeypot answers ok without a reference — never print "undefined".
          if (doneRef) doneRef.textContent = res.body.quoteNumber ? ' Your reference: ' + res.body.quoteNumber + '.' : '';
          if (doneEmail) doneEmail.textContent = payload.email || 'your email';
          try {
            sessionStorage.removeItem('gb_quote_display');
          } catch (e) {}
          window.scrollTo({ top: 0 });
        } else {
          errEl.textContent = (res.body && res.body.error) || "The request didn't send. Try again.";
          errEl.hidden = false;
          // Trade forms leave the address optional (the account address covers it).
          // If the server says there is none, make the fields required on the spot so
          // the fix is visible instead of a resubmit loop.
          if (/delivery address/i.test(errEl.textContent)) {
            ['addressLine1', 'city', 'country'].forEach(function (n) {
              if (form.elements[n]) form.elements[n].required = true;
            });
          }
        }
      })
      .catch(function () {
        delete send.dataset.busy;
        restore();
        errEl.textContent = "The request didn't send. Check your connection and try again.";
        errEl.hidden = false;
      });
  });
})();
